import { Helper } from '../../Helper';
export class CreateObjectHelper extends Helper {
    emit(sb, node, options) {
        if (options.pushValue) {
            sb.emitOp(node, 'NEWMAP');
            sb.emitOp(node, 'NEWMAP');
            sb.emitOp(node, 'NEWMAP');
            sb.emitPushInt(node, 3);
            sb.emitHelper(node, options, sb.helpers.packObject);
        }
    }
}

//# sourceMappingURL=CreateObjectHelper.js.map
